/**
 * Reversal_Service API client (task 21.2).
 *
 * | Method / Path                             | Function                | Req. |
 * | ----------------------------------------- | ----------------------- | ---- |
 * | `POST /transactions/{id}/reverse`         | {@link reverseTransaction} | R6.1 |
 *
 * The request carries an `Idempotency-Key` so a retried reversal is applied at
 * most once. Out-of-window and already-reversed cases surface as an
 * {@link ApiError} with code `REVERSAL_OUT_OF_WINDOW` (R6.2) / `ALREADY_REVERSED`
 * (R6.3), rendered inline by the reversal view.
 */

import { apiPost, newIdempotencyKey } from './client.js';
import type { TransferResult } from './types.js';

/**
 * Reverse an eligible transaction (within 3 calendar days SAST, not already
 * reversed) — atomic balance restore + reversing transaction, or no change
 * (R6.1, R6.5, R6.6).
 */
export function reverseTransaction(
  transactionId: string,
): Promise<TransferResult> {
  return apiPost<TransferResult>(
    `/transactions/${encodeURIComponent(transactionId)}/reverse`,
    {},
    { idempotencyKey: newIdempotencyKey() },
  );
}
